import { isNil } from 'lodash';
import React from 'react';
import { gridGap, width } from 'styled-system';
import { styled } from '~ui-kit/styled-components';
import { theme } from '~ui-kit/theme';
import { SectionProgressBarItemModel } from './models/section-progress-bar-item-model';
import { SectionProgressBarItem } from './section-progress-bar-item.component';

export interface SectionProgressBarProps {
  items: SectionProgressBarItemModel[];
  selectedItemId: string;
  onChange?: (selectedItem: SectionProgressBarItemModel, prevSelectedItem: SectionProgressBarItemModel) => void;
}

export function SectionProgressBar({ items = [], selectedItemId, onChange }: SectionProgressBarProps) {
  const selectedItemIndex = items.findIndex((item) => item.id === selectedItemId);

  const handleItemClicked = (item: SectionProgressBarItemModel) => {
    onChange?.(item, items?.[selectedItemIndex]);
  };

  return (
    <SectionProgressBarContainer>
      {items.map((item, index) => {
        const isDone = index < selectedItemIndex;

        return (
          <SectionProgressBarItem
            key={item.id}
            item={item}
            isActive={item.id === selectedItemId}
            isDone={isDone}
            isClickable={!isNil(onChange)}
            onClick={handleItemClicked}
          />
        );
      })}
    </SectionProgressBarContainer>
  );
}

const SectionProgressBarContainer = styled.div`
  font-family: ${theme.fontFamily.poppins};
  display: flex;
  flex-direction: row;

  ${gridGap({ gridGap: ['5px', '5px', '12px'] })}
  ${width({ width: ['100%', '100%', 'unset'] })}
`;
